import React from "react";

interface Props {
  title?: any;
}

export default function AddTitleToBroswerTab({ title }: Props) {
  React.useEffect(() => {
    // This will run when the page first loads and whenever the title changes
    document.title = title || "The Facilities Group";
  }, [title]);
  return <></>;
}
